<template>
  <div class="guangdaCard">
    <div class="head"></div>
    <div class="content fx-col fx-c-center">
      <input class="phone" placeholder="请输入您的手机号" v-model="phoneNo">
      <div class="get" @click="getVIP">立即领取</div>
    </div>
    <div class="rule"></div>
    <div class="getCard fx-row fx-m-center a-text-15">
      <div class="getCardClick fx fx-c-center fx-m-between" @click="getCard">
        <div>还没办吗?</div>
        <div>请戳这里</div>
        <div class="icon"></div>
      </div>
    </div>
  </div>
</template>
<script>
import env from "@/utils/env";
import nativeApi from "@/utils/native-api";
import weixinApi from "@/utils/weixinApi";
import ga from "@/utils/tracker.js";

import _ from "@/utils/validate";

import service from "../../service/index.js";
import { handleException } from "@/request/helpers.js";
import { get } from "@/request/utils";

export default {
  data() {
    return {
      phoneNo: null
    };
  },
  methods: {
    getCard() {
      location.href =
        "https://visa.rsscc.cn/active/pages/ceb-bank-new/index.html?type=gtgj&hlfrom=gtgjhy";
    },
    getVIP() {
      if (_.phone(this.phoneNo)) {
        service
          .guangdaCard({
            phone: this.phoneNo,
            actid: "GD0001"
          })
          .then(res => {
            let content = get(res, "res.bd.data.msg", {});
            let code = parseInt(get(res, "res.bd.data.code", {}));
            if (code === 1) {
              this.$popup({
                title: "管家提示",
                content,
                confirmButtonText: "立即领取",
                confirm: () => {
                  location.href =
                    "gtgj://start?type=weex&project_name=gtgj&hlo_module=gtgj&product_module=Membership&hlo_path=home&hlo_context_params=eyJsZXZlbCI6IjQifQ%3D%3D";
                }
              });
            } else if (code === 2) {
              this.$popup({
                title: "管家提示",
                content,
                confirm: () => {}
              });
            }
          })
          .catch(err => {
            handleException.call(this, err, true);
          });
      } else {
        this.$notify({
          message: "请填写正确的手机号",
          showClose: true
        });
      }
    },
    initShare() {
      // 配置分享
      let shareParams = {
        title: "免费领高铁白金会员！购票单单返现，办卡即可！",
        desc: "出行必备，优惠多多！赶紧办卡，免费领会员吧~",
        link: `https://h5.133.cn/gtgjwap/h5/vipCard/guangdaCard`,
        type: "weixin,pengyouquan",
        imgUrl: "https://cdn.133.cn/gtgj/web/guangdaCard/WechatIMG33.jpeg"
      };
      if (env.isNative) {
        nativeApi.invoke("updateHeaderRightBtn", {
          action: "show",
          text: "分享"
        });

        nativeApi.actions.headerRightBtnClick = function() {
          nativeApi.invoke("sharePage", shareParams);
          ga.track("vipCard/guangdaCard", "sharePage", "fromClient");
        };
      } else if (env.isWeixin) {
        weixinApi.share(
          Object.assign({}, shareParams, {
            success() {
              ga.track("vipCard/guangdaCard", "sharePage", "fromWechat");
            }
          })
        );
      }
    }
  },
  created() {
    // this.initShare();
  }
};
</script>
<style lang="scss" scoped>
@import "./style/common.scss";
@import "@/scss/_vars.scss";

.head {
  width: 375 * $px;
  height: 321 * $px;
  @include bg("head.jpg");
}
.content {
  width: 375 * $px;
  height: 100 * $px;
  @include bg("bg.jpg");
  background-repeat: repeat-y;
  .phone,
  .get {
    width: 267 * $px;
    height: 38 * $px;
    border-radius: 38 * $px;
    text-align: center;
    // color: #999;
    background-color: #fff;
    font-size: 16 * $px;
  }
  .get {
    line-height: 38 * $px;
    margin-top: 21 * $px;
    background-color: rgb(246, 207, 71);
    color: #663333;
    font-weight: 600;
  }
}
.rule {
  width: 375 * $px;
  height: 380 * $px;
  @include bg("WechatIMG78.jpeg");
}
.getCard {
  width: 375 * $px;
  height: 59 * $px;
  @include bg("bg.jpg");
  .getCardClick {
    width: 193 * $px;
    height: 28 * $px;
    line-height: 28 * $px;
    padding: 0 11 * $px;
    border: 2px solid #ffd95c;
    border-radius: 28 * $px;
    color: #ffd95c;
    text-align: center;
    font-weight: 600;
    .icon {
      width: 18 * $px;
      height: 18 * $px;
      @include bg("arrow.png");
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/vipCard/pages/guangdaCard/index.vue